export default "__VITE_ASSET__BepTJ28B__"